import { Classification } from "../../../../features/Classification";
import { ClassificationPage } from "../../../../pages/ClassificationPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const classifierPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.classify.root,
  element: <ClassificationPage />,
  name: "Классификация текстов",
  children: appRouterPaths.classify.item
    ? [
        {
          path: appRouterPaths.classify.item,
          element: <Classification />,
          name: "Классификация текста",
        },
      ]
    : undefined,
};
